import { gql } from '@apollo/client';

export const CREATE_PRODUCT_AVAILABILITY_NOTIFICATION = gql`
  mutation createProductAvailabilityNotification(
    $email: String!
    $productId: String!
    $productVariantId: String!
    $productVariantSku: String!
    $pdpVariantUrl: String
  ) {
    createProductAvailabilityNotification(
      options: {
        email: $email
        productId: $productId
        productVariantId: $productVariantId
        productVariantSku: $productVariantSku
        pdpVariantUrl: $pdpVariantUrl
      }
    )
  }
`;

export default {};
